import { render } from "./yxt_index.vue?vue&type=template&id=f7f6b6ae&scoped=true"
import script from "./yxt_index.vue?vue&type=script&lang=js"
export * from "./yxt_index.vue?vue&type=script&lang=js"

import "./yxt_index.vue?vue&type=style&index=0&id=f7f6b6ae&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f6b6ae"]])

export default __exports__